export default "__VITE_ASSET__C89FLXJ2__"